(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["parallax-home"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll('.scene').forEach(elem => {

  const modifier = elem.getAttribute('data-modifier');

  basicScroll.create({
    elem: elem,
    from: 0,
    to: 519,
    direct: true,
    props: {
      '--translateY': {
        from: '0',
        to: `${10 * modifier}px` } } }).


  start();

});

  } catch(e) { console.error(e); }
})();

})();
